module.exports = __webpack_public_path__ + "images/7a046bfb85954cc41d52eb8e09776d73.svg";